import Helmet from 'react-helmet'
import { LocalizationUtils } from '@ocean/utils'

type PageTitleProps = {
  title?: string
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  if (!title) return null
  return (
    <Helmet>
      <title>{LocalizationUtils.localize(title)}</title>
    </Helmet>
  )
}

export default PageTitle
